import HttpService from './http.service';
import MlvTranslation from '../models/MlvTranslations';

var leftLan = {
  SET_CONFIGURATIONS_BELOW: '',
  RESET_SELECTIONS_TO_BASE_MODEL: '',
  RESET_TO_DEFAULT: ''
};
var middleLan = {
  CONFIGURATION_CODE: '',
  CONFIG_CODE_SEARCH: '',
  ENTER_PART_NUMBER: '',
  SEARCH: '',
  NO_RESULTS_FOUND: '',
  SHARE_CONFIGURATION: '',
  SHARE: '',
  ENTER_VALID_EMAIL: '',
  INVALID_EMAIL_ADDRESS: '',
  SAVE: '',
  ENTER_CONFIG_NAME: '',
  SAVE_CONFIGURATION: '',
  LOAD_SAVED_CONFIGURATION: '',
  LOAD: '',
  DELETE: '',
  CANCEL: '',
  COPY_TO_CLIPBOARD: '',
  PRODUCT_EXAMPLE: '',
  PRODUCT_DESCRIPTION: '',
  PRODUCT_SERIES_GENERAL_SPECIFICATIONS: '',
  SUPPORT_DOCUMENTS: '',
  UPDATE: '',
  PREVIEW: '',
  FORMATS: '',
  CAD_SELECT_TEXT: '',
  CAD_FILTER_ALL: '',
  CAD_FILTER_ALL_3D: '',
  CAD_FILTER_ALL_2D: '',
  REFRESH_CAD: '',
  GENERATE_DATA_SHEET_PDF: '',
  GENERATE_CAD: '',
  ALERT_MESSAGE_INFO: '',
  ALERT_MESSAGE_LOAD: '',
  ALERT_MESSAGE_SUCCESS: '',
  ALERT_MESSAGE_LOAD_PDF: '',
  ALERT_MESSAGE_SUCCESS_PDF: '',
  ALERT_MESSAGE_RESET: '',
  CAD_FORMAT_DOWNLOAD: '',
  PREVIEW_NOT_AVAILABLE: ''
};
var rightLan = {
  QUANTITY: '',
  REQUEST_QUOTE: '',
  VIEW_SUMMARY_SHEET: '',
  CONFIGURATION_CODE: '',
  PRINT: '',
  CLOSE: '',
  FIND_A_DISTRIBUTOR: '',
  WHERE_TO_BUY: '',
  CONTACT_US: '',
  TELEPHONE: '',
  FAX: '',
  ADD_TO_CART: ''
};

const getTranslations = async lan => {
  let MlvKeys = MlvTranslation.keyNames();
  let keys = Object.values(MlvKeys);
  let paramArray = keys.map(x => +x).filter(x => !isNaN(x));
  var translations = {};
  await HttpService.postByObject('/translations/all/' + lan, paramArray)
    .then(res => {
      let temp_json = {};
      res.data.websiteTranslations?.map(ele => {
        temp_json[ele.key] = ele.value;
      });

      translations = assignTranslations(temp_json);
    })
    .catch(error => console.log(error));

  return translations;
};

const assignTranslations = temp_json => {
  let MlvKeys = MlvTranslation.keyNames();

  leftLan = {
    SET_CONFIGURATIONS_BELOW: getTranslation(
      temp_json,
      MlvKeys.SET_CONFIGURATIONS_BELOW
    ),
    RESET_SELECTIONS_TO_BASE_MODEL: getTranslation(
      temp_json,
      MlvKeys.RESET_SELECTIONS_TO_BASE_MODEL
    ),
    MODULE_STATIONS: getTranslation(temp_json, MlvKeys.MODULE_STATIONS),
    CLOSE: getTranslation(temp_json, MlvKeys.CLOSE),
    SAVE: getTranslation(temp_json, MlvKeys.SAVE),
    MOVE: getTranslation(temp_json, MlvKeys.MOVE),
    PART_NUMBER: getTranslation(temp_json, MlvKeys.PART_NUMBER),
    EDIT: getTranslation(temp_json, MlvKeys.EDIT),
    DUPLICATE: getTranslation(temp_json, MlvKeys.DUPLICATE),
    MOVE: getTranslation(temp_json, MlvKeys.MOVE),
    DELETE: getTranslation(temp_json, MlvKeys.DELETE),
    ADD_STATION: getTranslation(temp_json, MlvKeys.ADD_STATION),
    CANCEL: getTranslation(temp_json, MlvKeys.CANCEL),
    CONFIG_ENGINE_NOT_AVAILABLE: getTranslation(
      temp_json,
      MlvKeys.CONFIG_ENGINE_NOT_AVAILABLE
    ),
    RESET_TO_DEFAULT: getTranslation(temp_json, MlvKeys.RESET_TO_DEFAULT)
  };

  rightLan = {
    QUANTITY: getTranslation(temp_json, MlvKeys.QUANTITY),
    REQUEST_QUOTE: getTranslation(temp_json, MlvKeys.REQUEST_QUOTE),
    VIEW_SUMMARY_SHEET: getTranslation(temp_json, MlvKeys.VIEW_SUMMARY_SHEET),
    CONFIGURATION_CODE: getTranslation(temp_json, MlvKeys.CONFIGURATION_CODE),
    PRINT: getTranslation(temp_json, MlvKeys.PRINT),
    CLOSE: getTranslation(temp_json, MlvKeys.CLOSE),
    FIND_A_DISTRIBUTOR: getTranslation(temp_json, MlvKeys.FIND_A_DISTRIBUTOR),
    WHERE_TO_BUY: getTranslation(temp_json, MlvKeys.WHERE_TO_BUY),
    CONTACT_US: getTranslation(temp_json, MlvKeys.CONTACT_US),
    TELEPHONE: getTranslation(temp_json, MlvKeys.TELEPHONE),
    FAX: getTranslation(temp_json, MlvKeys.FAX),
    ADD_TO_CART: getTranslation(temp_json, MlvKeys.ADD_TO_CART)
  };

  middleLan = {
    CONFIGURATION_CODE: getTranslation(temp_json, MlvKeys.CONFIGURATION_CODE),
    CONFIG_CODE_SEARCH: getTranslation(temp_json, MlvKeys.CONFIG_CODE_SEARCH),
    ENTER_PART_NUMBER: getTranslation(temp_json, MlvKeys.ENTER_PART_NUMBER),
    SEARCH: getTranslation(temp_json, MlvKeys.SEARCH),
    NO_RESULTS_FOUND: getTranslation(temp_json, MlvKeys.NO_RESULTS_FOUND),
    SHARE_CONFIGURATION: getTranslation(temp_json, MlvKeys.SHARE_CONFIGURATION),
    SHARE: getTranslation(temp_json, MlvKeys.SHARE),
    ENTER_VALID_EMAIL: getTranslation(temp_json, MlvKeys.ENTER_VALID_EMAIL),
    INVALID_EMAIL_ADDRESS: getTranslation(
      temp_json,
      MlvKeys.INVALID_EMAIL_ADDRESS
    ),
    SAVE_CONFIGURATION: getTranslation(temp_json, MlvKeys.SAVE_CONFIGURATION),
    ENTER_CONFIG_NAME: getTranslation(temp_json, MlvKeys.ENTER_CONFIG_NAME),
    SAVE: getTranslation(temp_json, MlvKeys.SAVE),
    LOAD_SAVED_CONFIGURATION: getTranslation(
      temp_json,
      MlvKeys.LOAD_SAVED_CONFIGURATION
    ),
    LOAD: getTranslation(temp_json, MlvKeys.LOAD),
    DELETE: getTranslation(temp_json, MlvKeys.DELETE),
    CANCEL: getTranslation(temp_json, MlvKeys.CANCEL),
    COPY_TO_CLIPBOARD: getTranslation(temp_json, MlvKeys.COPY_TO_CLIPBOARD),
    PRODUCT_EXAMPLE: getTranslation(temp_json, MlvKeys.PRODUCT_EXAMPLE),
    PRODUCT_DESCRIPTION: getTranslation(temp_json, MlvKeys.PRODUCT_DESCRIPTION),
    PRODUCT_SERIES_GENERAL_SPECIFICATIONS: getTranslation(
      temp_json,
      MlvKeys.PRODUCT_SERIES_GENERAL_SPECIFICATIONS
    ),
    SUPPORT_DOCUMENTS: getTranslation(temp_json, MlvKeys.SUPPORT_DOCUMENTS),
    UPDATE: getTranslation(temp_json, MlvKeys.UPDATE),
    PREVIEW: getTranslation(temp_json, MlvKeys.PREVIEW),
    FORMATS: getTranslation(temp_json, MlvKeys.FORMATS),
    CAD_SELECT_TEXT: getTranslation(temp_json, MlvKeys.CAD_SELECT_TEXT),
    CAD_FILTER_ALL: getTranslation(temp_json, MlvKeys.CAD_FILTER_ALL),
    CAD_FILTER_ALL_3D: getTranslation(temp_json, MlvKeys.CAD_FILTER_ALL_3D),
    CAD_FILTER_ALL_2D: getTranslation(temp_json, MlvKeys.CAD_FILTER_ALL_2D),
    REFRESH_CAD: getTranslation(temp_json, MlvKeys.REFRESH_CAD),
    GENERATE_DATA_SHEET_PDF: getTranslation(
      temp_json,
      MlvKeys.GENERATE_DATA_SHEET_PDF
    ),
    GENERATE_CAD: getTranslation(temp_json, MlvKeys.GENERATE_CAD),
    ALERT_MESSAGE_INFO: getTranslation(temp_json, MlvKeys.ALERT_MESSAGE_INFO),
    ALERT_MESSAGE_LOAD: getTranslation(temp_json, MlvKeys.ALERT_MESSAGE_LOAD),
    ALERT_MESSAGE_SUCCESS: getTranslation(
      temp_json,
      MlvKeys.ALERT_MESSAGE_SUCCESS
    ),
    ALERT_MESSAGE_LOAD_PDF: getTranslation(
      temp_json,
      MlvKeys.ALERT_MESSAGE_LOAD_PDF
    ),
    ALERT_MESSAGE_SUCCESS_PDF: getTranslation(
      temp_json,
      MlvKeys.ALERT_MESSAGE_SUCCESS_PDF
    ),
    ALERT_MESSAGE_RESET: getTranslation(temp_json, MlvKeys.ALERT_MESSAGE_RESET),
    CAD_FORMAT_DOWNLOAD: getTranslation(temp_json, MlvKeys.CAD_FORMAT_DOWNLOAD),
    PREVIEW_NOT_AVAILABLE: getTranslation(
      temp_json,
      MlvKeys.PREVIEW_NOT_AVAILABLE
    )
  };

  let translations = {
    leftLan: leftLan,
    rightLan: rightLan,
    middleLan: middleLan
  };
  return translations;
};

const getTranslation = (translations, id) => {
  var translation = translations && translations[id];
  if (!translation) return 'NOT_TRANSLATED_' + id;

  return translation;
};

export { getTranslations, assignTranslations };
